export const decodeJwt = <T extends object>(token: string): T => {
  const [, payload] = token.split('.');
  return JSON.parse(atob(payload));
};
